import { render, staticRenderFns } from "./LockTokenAddDialog.vue?vue&type=template&id=2d05b67b&"
import script from "./LockTokenAddDialog.vue?vue&type=script&lang=js&"
export * from "./LockTokenAddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports